var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarryOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_397",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29263",
    "data-name": "Group 29263",
    transform: "translate(657 11099)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -657, -11099)",
    filter: "url(#Ellipse_397)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_397-2",
    "data-name": "Ellipse 397",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_8_",
    "data-name": "svgexport-17 (8)",
    transform: "translate(-631.834 -11084.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49879",
    "data-name": "Path 49879",
    d: "M349.324,125.318a.749.749,0,0,1-.749-.749v-6.1h-7.186v6.1a.749.749,0,1,1-1.5,0v-6.85a.749.749,0,0,1,.749-.749h8.685a.749.749,0,0,1,.749.749v6.85a.749.749,0,0,1-.749.749Zm0,0",
    transform: "translate(-333.648 -116.969)",
    fill: "#ffe785"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28910",
    "data-name": "Group 28910",
    transform: "translate(4.018 33.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49880",
    "data-name": "Path 49880",
    d: "M317.984,470.71a1.4,1.4,0,0,1-1.4-1.4v-2.9h2.8v2.9A1.4,1.4,0,0,1,317.984,470.71Zm11.835,0a1.4,1.4,0,0,1-1.4-1.4v-2.9h2.8v2.9A1.4,1.4,0,0,1,329.819,470.71Z",
    transform: "translate(-316.586 -466.414)",
    fill: "#1a414c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49885",
    "data-name": "Path 49885",
    d: "M297.153,190.151v20.213a4.018,4.018,0,0,1-4.019,4.018H278.5a4.018,4.018,0,0,1-4.018-4.018V190.151a4.018,4.018,0,0,1,4.018-4.018h14.632a4.018,4.018,0,0,1,4.019,4.018Zm0,0",
    transform: "translate(-274.485 -179.532)",
    fill: "#ce1b6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49886",
    "data-name": "Path 49886",
    d: "M323.944,190.151v20.213a4.018,4.018,0,0,1-4.019,4.018h-11.8a4.018,4.018,0,0,1-4.018-4.018V190.151a4.018,4.018,0,0,1,4.018-4.018h11.8a4.018,4.018,0,0,1,4.019,4.018Zm0,0",
    transform: "translate(-301.276 -179.532)",
    fill: "#f45395"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49887",
    "data-name": "Path 49887",
    d: "M337.159,118.468H325.6a.749.749,0,1,1,0-1.5h11.554a.749.749,0,1,1,0,1.5Zm0,0",
    transform: "translate(-320.048 -116.969)",
    fill: "#1a414c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49888",
    "data-name": "Path 49888",
    d: "M320.661,241.4a1.149,1.149,0,0,1-1.149-1.149V220.673a1.149,1.149,0,1,1,2.3,0v19.576a1.149,1.149,0,0,1-1.149,1.149Zm5.888,0a1.149,1.149,0,0,1-1.149-1.149V220.673a1.149,1.149,0,0,1,2.3,0v19.576a1.149,1.149,0,0,1-1.149,1.149Zm5.888,0a1.149,1.149,0,0,1-1.149-1.149V220.673a1.149,1.149,0,0,1,2.3,0v19.576a1.149,1.149,0,0,1-1.149,1.149Zm0,0",
    transform: "translate(-315.215 -209.736)",
    fill: "#ce1b6d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarryOn);
export default __webpack_public_path__ + "static/media/CarryOn.33c61892d6cb8c0f313ea344d4fd8cd1.svg";
export { ForwardRef as ReactComponent };